import { render, staticRenderFns } from "./ModalCourseInfo.vue?vue&type=template&id=052bd656&scoped=true&"
import script from "./ModalCourseInfo.vue?vue&type=script&lang=js&"
export * from "./ModalCourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalCourseInfo.vue?vue&type=style&index=0&id=052bd656&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bd656",
  null
  
)

component.options.__file = "ModalCourseInfo.vue"
export default component.exports